<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <h1>Rejestracja</h1>
              <p class="text-muted">Stwórz swoje konto</p>
              <p style="color: red" v-if="errors.length">
                <b>Popraw następujące błędy</b>
                <ul>
                  <li v-for="error in errors" :key="error">{{ error }}</li>
                </ul>
              </p>
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="icon-user"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <input v-model="username" type="text" class="form-control" placeholder="Username">
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text>@</b-input-group-text>
                </b-input-group-prepend>
                <input v-model="email" type="email" class="form-control" placeholder="Email">
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="icon-lock"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <input v-model="password" type="password" class="form-control" placeholder="Hasło">
              </b-input-group>

              <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="icon-lock"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <input v-model="repeatedPassword" type="password" class="form-control" placeholder="Powtórz hasło">
              </b-input-group>

              <b-button @click="register" variant="success" block>Stwórz konto</b-button>
            </b-card-body>
            <b-card-footer class="p-4">
              <router-link to="/auth/login">
                <b-button variant="link" class="px-0">Masz już konto? Zaloguj się!</b-button>
              </router-link>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errors: [],
      username: "",
      email: "",
      password: "",
      repeatedPassword: "",
      error: null
    };
  },
  methods: {
    async register() {
      this.errors = [];

      if (!this.username) {
        this.errors.push("Nazwa użytkownika jest wymagana.");
      }
      if (!this.password) {
        this.errors.push("Hasło jest wymagane.");
      }
      if (!this.repeatedPassword) {
        this.errors.push("Powtórz hasło.");
      } else if (
        this.repeatedPassword &&
        this.repeatedPassword != this.password
      ) {
        this.errors.push("Powtórzone hasło nie pasuję");
      }
      if (!this.email) {
        this.errors.push("Email jest wymagany.");
      } else if (!this.validEmail(this.email)) {
        this.errors.push("Nieprawidłowy adres email.");
      }

      if (this.errors.length) {
        return;
      }

      try {
        const user = await this.$auth.register({
            data: {
                fullName: this.username,
                email: this.email,
                password: this.password
            },
            success: function () {
                
            },
            error: function () {

            },
            autoLogin: true,
            rememberMe: true,
        });

      } catch (e) {
        if (e.response.data.message == "User already exist") {
          this.errors.push("Użytkownik o podanym adresie email już istnieje");
        }
      }
    },
    validEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
};
</script>
